import React from 'react';
import rightArrow from '../../assets/images/arrow_right_grey.png';
import upArrow from '../../assets/images/arrow_up.png';
import downArrow from '../../assets/images/arrow_down.png';
import Sparkline from './Sparkline';

interface CardProps {
  props: {
    title: string;
    value: string;
    change: number;
    isChangePositive?: boolean;
    recordName?: string;
    trend?: Array<{ label?: string; value: number }>;
  };
}

function KPICard({ props }: CardProps) {
  const { title, value, change, isChangePositive, recordName, trend = [] } = props;
  const positive = !!isChangePositive;

  return (
    <div className="p-6 rounded-lg bg-light hover:scale-[1.02] transform transition duration-200 ease-out">
      <div className="grid grid-cols-2 lg:gap-4 gap-2 mb-4">
        <div>
          <h3 className="text-md mb-2 text-grey_dark">{title}</h3>
          <h2 className="text-lg mb-2 text-dark truncated-figure-md" title={value}>
            {value}
          </h2>
          <div className="flex items-center mb-2">
            {positive ? (
              <img src={upArrow} alt="increase" className="h-5 w-5 text-primary" />
            ) : (
              <img src={downArrow} alt="decrease" className="h-5 w-5 text-danger" />
            )}
            <p className={`text-sm font-medium ${positive ? 'text-primary' : 'text-danger'}`}>
              {change}%
            </p>
          </div>
        </div>

        <div className="flex items-center justify-center min-h-[64px]">
          {trend.length > 0 ? (
            <Sparkline points={trend} positive={positive} height={72} />
          ) : (
            <div className="w-full h-[72px] rounded bg-bg_grey_light" aria-hidden="true" />
          )}
        </div>
      </div>
      <hr className="my-2 border-grey_light" />
      <div className="text-sm text-grey_dark flex items-center justify-between">
        {recordName} record
        <img src={rightArrow} alt="" className="inline-block ms-1 h-4 w-4" />
      </div>
    </div>
  );
}

export default KPICard;
